import { ScreenSize } from "../style/ScreenSize"

let node: HTMLDivElement | null = null

export const getToastStackRoot = () => {
  if (typeof document === 'undefined') return null
  if (node && document.body.contains(node)) return node

  node = document.createElement('div')
  node.id = 'info-toast-stack'
  Object.assign(node.style, {
    position: 'fixed',
    zIndex: '10000',
    top: '86px',
    right: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '12px',
    pointerEvents: 'none',
  })
  const mobileBreakpoint = ScreenSize.Sizes.lg - 1
  const mq = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`)
  const apply = () => {
    if (mq.matches) {
      node!.style.top = '10vh'
      node!.style.right = '0'
      node!.style.left = '0'
      node!.style.alignItems = 'center'
      node!.style.padding = '0 4vw'
    } else {
      node!.style.top = '86px'
      node!.style.right = '16px'
      node!.style.left = ''
      node!.style.alignItems = 'flex-end'
      node!.style.padding = ''
    }
  }
  apply()
  mq.addEventListener?.('change', apply)

  document.body.appendChild(node)
  return node
}
